import { IId } from '../models/types';

const ROLE_ID_FIELD_SUFFIX = 'roleId';

export const parseRoleIdFromFieldKey = (roleIdKey: string): IId => {
  if (roleIdKey.endsWith(ROLE_ID_FIELD_SUFFIX)) {
    return roleIdKey.slice(0, -ROLE_ID_FIELD_SUFFIX.length);
  }

  return roleIdKey;
};

// POST /user/sectree/acl is treated as upsert per (uid, roleId, action) tuple.
// Do not send a single-node subset unless backend replace semantics are confirmed.
export const buildRightsAclPayload = (
  actions: Record<string, Record<string, Record<string, boolean>>> | undefined
) => {
  const resultArray: Array<{ uid: IId; roleId: IId; action: string; result: string }> = [];

  if (!actions) {
    return resultArray;
  }

  for (const uid of Object.keys(actions)) {
    for (const roleIdKey of Object.keys(actions[uid])) {
      const roleId = parseRoleIdFromFieldKey(roleIdKey);

      for (const action of Object.keys(actions[uid][roleIdKey])) {
        resultArray.push({
          uid,
          roleId,
          action,
          result: actions[uid][roleIdKey][action] ? 'Grant' : 'Deny'
        });
      }
    }
  }

  return resultArray;
};

export const buildRoleAclPayload = (
  actions: Record<string, Record<string, boolean>> | undefined,
  roleId: IId
) => {
  if (!actions) {
    return [];
  }

  return Object.entries(actions).flatMap(([uid, nodeActions]) =>
    Object.entries(nodeActions).map(([action, result]) => ({
      uid,
      action,
      roleId,
      result: result ? 'Grant' : 'Deny'
    }))
  );
};
